import React, { useContext } from "react";
import { Badge } from "reactstrap";
import { StateContext } from "../../../utils/context";
import { Link } from "react-router-dom";

const UserTokens = () => {
  const { currentUser } = useContext(StateContext);
  const tokens = currentUser.tokens || 0;

  return (
    <Link to="/tokens">
      <Badge
        color="primary"
        className="mr-3"
        style={{ display: "inline-flex", alignItems: "center", marginTop: "8px", padding: "10px 12px", borderRadius: "8px" }}
      >
        <i className="mdi mdi-hexagon-multiple mr-1" style={{ fontSize: "20px", color: "#ffffff", marginTop: "2px" }}></i>
        <span style={{ color: "#ffffff", fontSize: "18px", fontStyle: "normal", fontWeight: "bold" }}>
          &nbsp;{tokens}{" "}
          {tokens <= 1 ? "Token" : "Tokens"}
        </span>
      </Badge>
    </Link>
  );
};

export default UserTokens;